import {Component} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CacheInfoService} from "./cache_info.service";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<select [(ngModel)]="flag" [ngModelOptions]="{standalone: true}" class="form-control">
				<option *ngFor="let opt of cacheTaskList"
						value="{{ opt }}" [selected]="opt == flag">
					{{ opt }}
				</option>
			</select>
		</info-modal>
	`
})
export class StartCacheInfoComponent extends InfoModalComponent {
	cacheTaskList: string[];
	flag: string;

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public service: CacheInfoService
	) {
		super(activeModal);
	}

	async ok() {
		console.log('flag', this.flag);

		await this.service.startPid(this.flag).toPromise();
		await this.close();
	}
}
